import script from "./MTB_PatientList.vue?vue&type=script&setup=true&lang=js"
export * from "./MTB_PatientList.vue?vue&type=script&setup=true&lang=js"

import "./MTB_PatientList.vue?vue&type=style&index=0&id=2027bcb0&lang=css"

const __exports__ = script;

export default __exports__